import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SimpleTextFieldComponent } from './simple-text-field/simple-text-field.component';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { DirectivesModule } from '../../common';

@NgModule({
  declarations: [SimpleTextFieldComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    FieldErrorMessagesModule,
    MatInputModule,
    ReactiveFormsModule,
    DirectivesModule,
  ],
  exports: [SimpleTextFieldComponent],
})
export class SimpleTextFieldModule {}
